// Social Wall
var svgFacebook = '<svg width="20px" height="20px" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28.1456 23.4793L28.8623 19.1915H24.3813V16.4091C24.3813 15.236 25.0072 14.0926 27.0141 14.0926H29.0513V10.442C29.0513 10.442 27.2026 10.1523 25.4351 10.1523C21.7449 10.1523 19.3328 12.206 19.3328 15.9236V19.1915H15.2308V23.4793H19.3328V33.8447H24.3813V23.4793H28.1456Z" fill="#FFF"/></svg>';
var svgInstagram = '<svg width="20px" height="20px" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.9968 18.0481C19.8216 18.0481 18.0465 19.8233 18.0465 21.9985C18.0465 24.1737 19.8216 25.9489 21.9968 25.9489C24.172 25.9489 25.9471 24.1737 25.9471 21.9985C25.9471 19.8233 24.172 18.0481 21.9968 18.0481ZM33.8448 21.9985C33.8448 20.3626 33.8596 18.7416 33.7678 17.1087C33.6759 15.212 33.2432 13.5287 31.8563 12.1418C30.4665 10.7519 28.7862 10.3221 26.8895 10.2303C25.2537 10.1384 23.6327 10.1532 21.9998 10.1532C20.3639 10.1532 18.7429 10.1384 17.11 10.2303C15.2134 10.3221 13.5301 10.7548 12.1432 12.1418C10.7533 13.5317 10.3236 15.212 10.2318 17.1087C10.1399 18.7445 10.1547 20.3656 10.1547 21.9985C10.1547 23.6314 10.1399 25.2554 10.2318 26.8883C10.3236 28.785 10.7563 30.4683 12.1432 31.8552C13.5331 33.2451 15.2134 33.6748 17.11 33.7667C18.7459 33.8586 20.3669 33.8438 21.9998 33.8438C23.6356 33.8438 25.2566 33.8586 26.8895 33.7667C28.7862 33.6748 30.4694 33.2422 31.8563 31.8552C33.2462 30.4653 33.6759 28.785 33.7678 26.8883C33.8626 25.2554 33.8448 23.6344 33.8448 21.9985V21.9985ZM21.9968 28.0767C18.6333 28.0767 15.9187 25.3621 15.9187 21.9985C15.9187 18.6349 18.6333 15.9203 21.9968 15.9203C25.3604 15.9203 28.0749 18.6349 28.0749 21.9985C28.0749 25.3621 25.3604 28.0767 21.9968 28.0767ZM28.3238 17.0909C27.5385 17.0909 26.9043 16.4567 26.9043 15.6713C26.9043 14.886 27.5385 14.2518 28.3238 14.2518C29.1092 14.2518 29.7434 14.886 29.7434 15.6713C29.7436 15.8578 29.707 16.0425 29.6358 16.2148C29.5645 16.3872 29.46 16.5438 29.3281 16.6756C29.1963 16.8075 29.0397 16.912 28.8674 16.9833C28.695 17.0546 28.5103 17.0911 28.3238 17.0909V17.0909Z" fill="#FFF"/></svg>';

setTimeout(() => {
    var items = document.querySelectorAll('.ff-item');
    var labels = document.querySelectorAll('.ff-icon-inner');

    items.forEach(function(item) {
        var feedValue = item.getAttribute('data-feed');
        var name = item.querySelector('.ff-label-text');

        switch (feedValue) {
            case "ia37365":
            case "vy00057":
                name.textContent = "Ville de Guer";
            break;
            
            case "sf28219":
                name.textContent = "Médiathèque de Guer";
            break;
                        
            case "bu19123":
                name.textContent = "De l'Oust à Broceliande communauté";
            break;
            
            case "kp07698":
                name.textContent = "Jumelage Guer-Gravedona";
            break;
            
            default:
                name.textContent = "Guer";
        }
    });

    labels.forEach(function (label) {
        if (label.closest('.ff-item').classList.contains('ff-facebook')) {
            label.insertAdjacentHTML('afterbegin', svgFacebook);
        }

        if (label.closest('.ff-item').classList.contains('ff-instagram')) {
            label.insertAdjacentHTML('afterbegin', svgInstagram);
        }
    });

}, "2000")